import axios from "axios";
import { getCookie } from "./cookieFunction";
import {
  fetchToastNotify,
  fetchWait,
} from "../../controller/redux/app-reducer";
import { fetchLoginFailure } from "../../controller/redux/login-reducers";
import { isEmpty, decode } from "./commonFunction";
import * as CONSTANTS from "./constants";
import { HCCCD_API } from "../../controller/api";
import { CHECK_ATTT } from "config";

let isSwitchingUnit = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

export const axiosConfig = async (store) => {
  let countRequest = 0;
  let countResponse = 0;
  let csrfToken = null;
  let csrfPromise = null;

  const loadCsrfToken = async () => {
    if (!CHECK_ATTT) return;
    if (csrfToken) return csrfToken;
    if (csrfPromise) return csrfPromise;
    csrfPromise = (async () => {
      try {
        const res = await axios.get(`${HCCCD_API}/csrf/csrf-token`, {
          withCredentials: true,
        });
        csrfToken = res.data?.csrfToken;
        if (csrfToken)
          axios.defaults.headers.common["X-CSRF-Token"] = csrfToken;
      } catch (err) {
        console.error("CSRF Error", err);
      } finally {
        csrfPromise = null;
      }
    })();
    return csrfPromise;
  };

  loadCsrfToken();

  axios.interceptors.request.use(
    async (config) => {
      const state = store.getState();
      // 1. Nếu là API đổi đơn vị: Cho qua ngay lập tức
      if (config.url.includes("/token-switch-unit")) {
        isSwitchingUnit = true;
        const loginRes = store.getState().LoginRes;
        if (loginRes?.access_token)
          config.headers["Authorization"] = `Bearer ${loginRes.access_token}`;
        return config;
      }

      // 2. Nếu đang đổi đơn vị: Cho các request khác vào hàng đợi
      if (
        isSwitchingUnit &&
        state.LoginRes?.isSwitching &&
        !config.url.includes("/csrf/")
      ) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            config.headers["Authorization"] = `Bearer ${token}`;
            return config;
          })
          .catch((err) => Promise.reject(err));
      }

      // 3. Request bình thường
      if (!config.url.includes("/csrf/") && !csrfToken) {
        await loadCsrfToken();
      }

      // Ưu tiên lấy token từ Cookie (nguồn mới nhất)
      let token = null;
      try {
        const cookieData = getCookie(CONSTANTS.AUTHORIZATION_COOKIE);
        token = cookieData
          ? JSON.parse(decode(cookieData)).access_token
          : store.getState().LoginRes?.access_token;
      } catch (e) {
        //token = store.getState().LoginRes?.access_token;
      }

      // Nếu cookie không có, bắt buộc lấy từ Redux
      if (!token) {
        token = state.LoginRes?.access_token;
      }

      if (token) config.headers["Authorization"] = `Bearer ${token}`;

      const method = config.method?.toUpperCase();
      if (
        ["GET", "POST", "PUT", "DELETE", "PATCH"].includes(method) &&
        csrfToken
      ) {
        config.headers["X-CSRF-Token"] = csrfToken;
        config.withCredentials = true;
      }

      countRequest++;
      store.dispatch(fetchWait(true));
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    async (res) => {
      countResponse++;
      handleResponseCount(store, countRequest, countResponse);

      if (res.config.url.includes("/token-switch-unit")) {
        isSwitchingUnit = false;
        processQueue(null, res.data?.access_token);
      }

      const dataType = Object.prototype.toString.call(res.data);
      const isPlainObject = dataType === "[object Object]";
      if (
        isPlainObject &&
        (res.status === 200 || res.status === 201) &&
        isEmpty(res.data)
      ) {
        res.data = true;
      }
      return res;
    },
    async (error) => {
      countResponse++;
      handleResponseCount(store, countRequest, countResponse);

      if (error.config?.url.includes("/token-switch-unit")) {
        isSwitchingUnit = false;
        processQueue(error, null);
      }

      if (
        error.response?.status === 401 ||
        !error.config.headers["Authorization"]
      ) {
        store.dispatch(fetchLoginFailure({}));
        return Promise.reject(error);
      }

      if (
        error.response?.status === 403 &&
        error.response.data?.error?.includes("CSRF")
      ) {
        await loadCsrfToken();
        error.config.headers["X-CSRF-Token"] = csrfToken;
        return axios(error.config);
      }

      if (!error.config?.skipGlobalToast) {
        handleRequestError(store, error);
      }
      return Promise.reject(error);
    }
  );
};

const handleRequestError = (store, error) => {
  console.log(error);
  store.dispatch(
    fetchToastNotify({
      type: CONSTANTS.ERROR,
      data:
        error?.response?.data?.message ||
        "Hệ thống đang bận xin vui lòng thử lại sau ít phút",
    })
  );
};

const handleResponseCount = (store, req, res) => {
  if (res >= req) store.dispatch(fetchWait(false));
};